export default "__VITE_ASSET__ZOMqfJAd__"